import _ from 'lodash'
import { twMerge } from 'tailwind-merge'
import NextLink from 'next/link'

type Props = {
  href: string | any
  useStyle?: boolean
} & (React.ComponentPropsWithoutRef<typeof NextLink>)

export function Link({ className, useStyle, children, ...props }: Props) {
  className = twMerge(
    'underline-offset-4 group transition-all duration-300 hover:underline',
    useStyle
      ? 'text-red-800 hover:text-red-700 dark:text-red-400 dark:hover:text-red-500'
      : 'hover:text-red-800 dark:hover:text-red-500',
    className,
  )
  return (
    <NextLink hrefLang='en' scroll={true} className={className} {...props}>
      {children}
    </NextLink>
  )
}